import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface Locale {
  language: string;
  country: string;
}

interface I18nState {
  appLanguage: Locale | null;

  availableLanguages: Locale[];
}

const initialState: I18nState = {
  appLanguage: null,
  availableLanguages: [],
};

const i18nSlice = createSlice({
  name: 'i18n',
  initialState,
  extraReducers: builder => builder.addCase('resetStore', () => initialState),
  reducers: {
    updateAppLanguage: (state, action: PayloadAction<Locale>) => {
      state.appLanguage = action.payload;
    },
    updateAvailableLanguages: (state, action: PayloadAction<Locale[]>) => {
      state.availableLanguages = action.payload;
    },
  },
});

export const {
  reducer: i18nReducer,
  actions: { updateAppLanguage, updateAvailableLanguages },
} = i18nSlice;
